import React from 'react'
import {renderMoney} from '../../utils'

class WalletBalance extends React.Component {
    render() {
        return(
            <div className='wallet-recharge-header'>
                <div className='balance'>
                    {renderMoney(this.props.balance)}
                </div>
                <div className='balance-description'>
                    账户余额（荔枝币）
                </div>
            </div>
        )
    }
}
export default WalletBalance


// WEBPACK FOOTER //
// ./src/components/wallet/WalletIapBalance.js